import { Api } from "../config/request";

export default {
  driverSelectionCSVUpload(payload) {
    return Api.post("/stories/upload_csv", payload);
  },
  uploadCampaignImage(payload) {
    return Api.post("/stories/upload_image", payload);
  },
  uploadCampaignVideo(payload) {
    return Api.post("/stories/upload_video", payload);
  },
  createCampaign(payload) {
    return Api.post("/stories/create_campaign", payload);
  },
  createExternalBrand(payload) {
    return Api.post("/stories/create_external_entity", payload);
  },
  viewExternalBrands() {
    return Api.get("/stories/view_external_entities");
  },
  fetchStoriesList(payload) {
    return Api.post("/stories/list", payload);
  },
  getActiveCampaign(campaign_id) {
    return Api.get(`/stories/detail?story_id=${campaign_id}`);
  },
  deactivateStory(payload) {
    return Api.post(`/stories/update`, payload);
  },
  createStoryCampaign(payload) {
    return Api.post(`/stories/create`, payload);
  },
  getDriverDetails(driverId) {
    return Api.get(`/drivers?driver_id=${driverId}`);
  },
  createExternalEntity(payload) {
    return Api.post(`/stories/external-entity/create`, payload);
  },
  getExternalEntitiesList(payload) {
    return Api.post(`/stories/external-entity/list`, payload);
  },
  getExternalEntity(payload) {
    return Api.post(`/stories/external-entity`, payload);
  },
};
